import { useFormik, FormikProvider } from 'formik';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import { Input } from '../../components/form';
import { Button, Card } from '../../components/UI';
import {
  confirmPasswordValidator,
  passwordValidator,
} from '../../components/form/Input/validators/password-validator';

import { useAuth } from '../../context/Auth';

const AccountCredentials = () => {
  const { t } = useTranslation();
  const { changePassword } = useAuth();

  const formik = useFormik({
    initialValues: {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    },
    onSubmit: async ({ oldPassword, newPassword }) => {
      changePassword(oldPassword, newPassword)
        .then((res) => {
          formik.setSubmitting(false);
          toast.success(t('account.success.savePassword'));
        })
        .catch((err) => {
          toast.success(t('account.error.savePassword'));
        });
    },
    validateOnMount: true,
  });

  return (
    <Card className="relative mt-4" title="reset password">
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit} autoComplete={'off'}>
          <div className="flex justify-start align-center">
            <div className="flex flex-col gap-5 w-full">
              <div className="flex flex-col md:flex-row gap-5 justify-between align-center">
                <Input
                  size="full"
                  name="oldPassword"
                  id="oldPassword"
                  formik={formik}
                  validate={passwordValidator}
                  type="password"
                  placeholder={t(
                    'account.credentials.form.placeholder.oldPassword'
                  )}
                />
                <Input
                  size="full"
                  name="newPassword"
                  id="newPassword"
                  formik={formik}
                  type="password"
                  validate={passwordValidator}
                  showPasswordHint={true}
                  placeholder={t(
                    'account.credentials.form.placeholder.newPassword'
                  )}
                />
                <Input
                  size="full"
                  name="confirmNewPassword"
                  id="confirmNewPassword"
                  formik={formik}
                  type="password"
                  validate={() =>
                    confirmPasswordValidator(
                      formik.values.confirmNewPassword,
                      formik.values.newPassword
                    )
                  }
                  placeholder={t(
                    'account.credentials.form.placeholder.confirmPassword'
                  )}
                />
              </div>
              <div className="flex justify-end">
                <Button
                  type="submit"
                  variant="primary"
                  loading={formik.isSubmitting}
                >
                  {t('account.credentials.form.placeholder.confirmPassword')}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </FormikProvider>
    </Card>
  );
};

export { AccountCredentials };
